export default "__VITE_PUBLIC_ASSET__0c306543__"